export const regexConstants = {
    password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^\w\s]).{8,}$/,
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-z0-9-]+\.)+[A-Za-z]{2,}))$/,
    // phoneNumber: /^[+]?[(]?[0-9]{1,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,7}$/im,
    phoneNumber: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
    fax: /^\+?[0-9]+$/,
    // phoneNumber:/^\+[1-9]{1}[0-9]{3,14}$/,
    alphanumericWithOutSpace: /^[0-9a-zA-Z]+$/,
    alphanumericWithSpace: /^[0-9a-zA-Z\s]+$/,
    // alphanumericWithHyphen: /^[\w\-]+$/,
    numericWithHyphen: /^[\d-]+$/,
    // characterWithHyphen: /^[a-zA-Z\-]+$/,
    onlyNumeric: /^(\d+)$/,
    percentageStrict: /^(100(\.00?)?|([1-9]?[0-9])(\.\d{1,2})?)$/,
    percentageStrictDecimal: /^(100(\.0{0,2})?|([1-9]?[0-9])(\.\d{0,2})?)$/,
    onlyCharacter: /^[a-zA-Z]+$/,
    numberWithDot: /^[0-9]*(\.\d{0,2})?$/,
    numberWith4Dot: /^[0-9]*(\.\d{0,4})?$/,
    alphanumericWithHyphenSpace: /^[\w\s]+([-]{1}[\w\s]+)*$/,
    alphanumericWithHyphen: /^[\w]+(-[\w]+)*$/,
    characterWithHyphen: /^[a-zA-Z]+([-]{1}[a-zA-Z]+)*$/,
    characterWithHyphenSpace: /^[a-zA-Z\s]+([-]{1}[a-zA-Z\s]+)*$/,
    characterWithSpace: /^[a-zA-Z\s]+$/,
    onlyNumericExcludeZero: /^([1-9]*|[1-9]*\.[1-9]{1}?[1-9]*)$/,
    tsnRegex: /^\d{1,15}(\.\d{0,15})?$/,
    csnRegex: /^\d{1,15}$/,
    decimalnodotstart: /^(?!^\.)[0-9]*(\.\d{0,2})?$/,
    percantageRegExp: /^$|^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/,
    leaseTsnCsn:/^\d{0,12}(\.\d?)?$/,
    isValidNumeric: /^\d{0,12}$/,
    numberNotStartwithZero: /^[1-9][0-9]*(\.?[0-9]*)?$/,
    // decimalnodotstartwithVariables: /^(?!^\.)[0-9]*(\.\d{0,2})?$/,
    noStartingSpace: /^(\S.*)?$/,
    numberWithSpecChar: /^[\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>\/? ]+$/,
    decimalNoDotStartWithVariables: (limit) => new RegExp(`^(?!^\\.)[0-9]*(\\.\\d{0,${limit}})?$`),
    restrictUnicodeCharacters: /^(?![\s\S]*[\u{1F300}-\u{1FAFF}\u{1F100}-\u{1F1FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}])[\s\S]+$/u,
    numWithComa: /^[0-9,]*$/,
    derateRegex: /^((100(\.0{0,2})?|[0-9]{1,2}(\.\d{0,2})?)(,(100(\.0{0,2})?|[0-9]{1,2}(\.\d{0,2})?)?)*)?$/,
    positiveIntegerNoZero: /^[1-9]\d*$/,
}
